import React, { useEffect, useState } from "react";
import { PrismicRichText } from "@prismicio/react";
import { GatsbyImage } from "gatsby-plugin-image";
import { Container, Row, Col } from "react-bootstrap";
import Anchor from "../elements/Anchor";

import "../../styles/components/slices/text_image.scss";

const TextImage = ({ slice }) => {
  if (!slice) return null;

  let url = slice.primary.image.gatsbyImageData;

  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 0
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (windowWidth <= 768) {
    if (slice.primary.image_mobile) {
      url = slice.primary.image.gatsbyImageData;
    } else {
      url = slice.primary.image.gatsbyImageData; // Fallback
    }
  } else {
    url = slice.primary.image.gatsbyImageData;
  }

  return (
    <Container
      fluid
      style={
        slice.primary.background_image.gatsbyImageData
          ? {
              backgroundImage: `url(${slice.primary.background_image.gatsbyImageData.images.fallback.src})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }
          : {}
      }
      className={slice.primary.custom_style ? "custom-style" : ""}
    >
      <Container className="text-image max-container">
        <Row className="justify-content-center">
          <Col
            xs={11}
            md={`${slice.primary.custom_style ? "6" : "7"}`}
            className={`align-self-center ${
              slice.primary.alignment ? "order-md-2 offset-0 offset-md-1" : ""
            }`}
          >
            <div className="title">
              <h3
                className={
                  slice.primary.custom_style
                    ? "title-65 mb-4 line-h-75"
                    : "mb-4"
                }
              >
                {slice.primary.title.text}
              </h3>
            </div>
            <div
              className={`descr ${slice.primary.custom_style ? "mb-5" : ""}`}
            >
              <PrismicRichText field={slice.primary.description.richText} />
            </div>
            {slice.primary.button_label !== null &&
              slice.primary.button_link.url !== null && (
                <div className="book-now-outline me-auto d-none d-lg-block mt-5 mona">
                  <Anchor
                    href={slice.primary.button_link.url}
                    className="book-now-btn text-center"
                    target={slice.primary.button_link.target}
                  >
                    {slice.primary.button_label}
                  </Anchor>
                </div>
              )}
          </Col>
          <Col
            md={`${slice.primary.custom_style ? "5" : "4"}`}
            className={`align-self-center ${
              slice.primary.alignment ? "order-1" : "offset-0 offset-md-1"
            }`}
          >
            <GatsbyImage
              image={url}
              alt={slice.primary.image.alt || "image"}
              className={slice.primary.border_radius ? "border-radius" : ""}
            />
          </Col>
        </Row>
        {slice.primary.outer_button && (
          <Row>
            <div className="book-now-outline mt-5 mona mx-auto w-auto">
              <Anchor
                href={slice.primary.outer_button_link.url}
                target={slice.primary.outer_button_link.target}
                className="book-now-btn text-center"
              >
                {slice.primary.outer_button}
              </Anchor>
            </div>
          </Row>
        )}
      </Container>
    </Container>
  );
};

export default TextImage;
